export const BASE_DATA_TYPES = {
  PIPELINE_SP_THREAT: 'PIPELINE_SP_THREAT'
}
